import React from "react";
import {
  AuditOutlined, BankOutlined, CheckCircleOutlined, DashboardOutlined,
  SafetyCertificateOutlined, SettingOutlined, SwapOutlined, TeamOutlined, MobileOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import { Link, useLocation } from "react-router-dom";
import { hasPermission } from "../../auth/permissions";
import { useAuth } from "../../auth/session";

export default function SideNav({ onNavigate }) {
  const { user } = useAuth();
  const location = useLocation();
  const items = [
    hasPermission(user, "dashboard:view")
      ? { key: "/dashboard", icon: <DashboardOutlined />, label: <Link to="/dashboard">Tổng quan</Link> }
      : null,
    hasPermission(user, "users:view")
      ? { key: "/system/users", icon: <TeamOutlined />, label: <Link to="/system/users">Người dùng</Link> }
      : null,
    hasPermission(user, "ip-access:view")
      ? { key: "/system/ip-access", icon: <SafetyCertificateOutlined />, label: <Link to="/system/ip-access">Bảo mật IP</Link> }
      : null,
    hasPermission(user, "categories:edit")
      ? { key: "/system/settings", icon: <SettingOutlined />, label: <Link to="/system/settings">Cấu hình chung</Link> }
      : null,
    hasPermission(user, "accounts:view")
      ? { key: "/bank-accounts", icon: <BankOutlined />, label: <Link to="/bank-accounts">Tài khoản ngân hàng</Link> }
      : null,
    hasPermission(user, "devices:view")
      ? { key: "/devices", icon: <MobileOutlined />, label: <Link to="/devices">Quản lý tài nguyên</Link> }
      : null,
    hasPermission(user, "transactions:view")
      ? { key: "/transactions", icon: <SwapOutlined />, label: <Link to="/transactions">Giao dịch tiền vào / ra</Link> }
      : null,
    hasPermission(user, "reconciliations:view")
      ? { key: "/reconciliations", icon: <CheckCircleOutlined />, label: <Link to="/reconciliations">Đối soát ngày</Link> }
      : null,
    hasPermission(user, "audit:view")
      ? { key: "/system/audit-logs", icon: <AuditOutlined />, label: <Link to="/system/audit-logs">Nhật ký hoạt động</Link> }
      : null,
  ].filter(Boolean);
  return <Menu className="app-side-menu" theme="dark" mode="inline" selectedKeys={[location.pathname]} onClick={onNavigate} items={items} />;
}

